<template>
  <page>
    <div>
      <v-flex xs12>
        <form action="">
          <v-expansion-panels>
          <v-expansion-panel>
              <v-expansion-panel-header>
              <div>
                <v-icon>mdi-filter-variant</v-icon> Filters
              </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex xl3 lg6 xs6>
                        <v-text-field v-model="filters.busCls" :label="labels.busCls" :error-messages="errors.collect('busCls')" data-vv-name="busCls" :data-vv-as="labels.busCls" v-validate="'name|max:20'"></v-text-field>
                      </v-flex>
                      <v-flex xl3 lg6 xs6>
                        <v-text-field v-model="filters.resCat" :label="labels.resCat" :error-messages="errors.collect('resCat')" data-vv-name="resCat" :data-vv-as="labels.resCat" v-validate="'name|max:20'"></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                  <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </form>
      </v-flex>
      <v-spacer class="mt-2"></v-spacer>
      <v-card>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click.native="doNew()">
            New Permitted Reserve Category
            <v-icon right>mdi-plus</v-icon>
          </v-btn>
        </v-card-title>
        <v-flex>
          <v-card>
            <v-data-table :headers="headers" :items="items" v-bind:options.sync="pagination" :server-items-length="totalItems" :loading="loading" :footer-props="{'items-per-page-options': itemsPerPage }" :no-data-text="noDataText">
              <template v-slot:item="row"><tr>
                <td>{{ row.item.busCls }}</td>
                <td>{{ row.item.busClsDesc }}</td>
                <td>{{ row.item.resCat }}</td>
                <td>{{ row.item.resCatLongDesc }}</td>
                <td class="table-action-header">
                  <table-action :rowData="row" review @review="doReview(row.item.busCls, row.item.resCat)" query @query="doQuery(row.item.busCls, row.item.resCat)" remove @remove="doPromptRemove(row.item)"></table-action>
                </td>
              </tr></template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-card>
      <confirm v-model="promptRemove" @ok="doRemove">
        Are you sure you want to delete the selected Permitted Reserve Category Per Business Class?
      </confirm>
    </div>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'

export default {
  data() {
    return {
      toogleArray: [false],
      headers: [
        { text: 'Business Class', value: 'busCls' },
        { text: 'Description', value: 'busClsDesc' },
        { text: 'Reserve Category', value: 'resCat' },
        { text: 'Description, Long', value: 'resCatLongDesc' },
        TableConst.tableActionHeader
      ],
      labels: {
        busCls: 'Business Class',
        resCat: 'Claims Reserve Category',
        busClsDesc: 'Description',
        resCatDescLong: 'Description, Long'
      },
      filters: {
        busCls: undefined,
        resCat: undefined
      },
      totalItems: 0,
      selecetedBusCls: undefined,
      deleteBusCls: '',
      loading: false,
      promptRemove: false,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  watch: {
    'pagination': function (value) {
      this.doInit(false)
    }
  },
  methods: {
    async doInit(options) {
      this.resetMessages()
      const apiURI = this.menu.getList
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filters, this.pagination.sortBy, this.pagination.sortDesc))
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((datamap) => {
                const convertList = {
                  busCls: datamap.busCls,
                  busClsDesc: datamap.busClsDesc,
                  resCat: datamap.resCat,
                  resCatLongDesc: datamap.resCatLongDesc
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    doClearFilters() {
      this.resetMessages()
      this.filters.busCls = null
      this.filters.resCat = null
      this.pagination.page = 1
      this.doInit(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.pagination.page = 1
          this.doInit(false)
        }
      })
    },
    doReview(busCls, clmResCat) {
      this.$router.push({ name: 'pmtClmResCatPerBusClsReview', params: { busCls: busCls, clmResCat: clmResCat, pmtClmResCatMode: 'Review' } })
    },
    doQuery(busCls, clmResCat) {
      this.$router.push({ name: 'pmtClmResCatPerBusClsReview', params: { busCls: busCls, clmResCat: clmResCat, pmtClmResCatMode: 'Query' } })
    },
    doNew() {
      this.$router.push({ name: 'pmtClmResCatPerBusClsReview', params: { busCls: 'new', clmResCat: 'new', pmtClmResCatMode: 'New' } })
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selecetedBusCls = data
        this.deleteBusCls = data.busCls
      }
    },
    async doRemove() {
      const apiURI = this.menu.deletePmtClmResCatPerBusCls
      if (apiURI) {
        const expand = this.selecetedBusCls
        this.$http
          .post(apiURI, expand)
          .then((result) => {
            const data = result.data
            this.notify(data)
            this.doInit(true)
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
            }
          })
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.pmtClmResCatPerBusClsParam.menu
    }
  },
  mounted() {
    this.doInit(true)
  },
  created() {},
  mixins: [TableConst.default, MessageMixin]
}
</script>
